module.exports = __webpack_public_path__ + "img/viral-transmission-of-sars-cov-2-image.740b3917.png";